/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Viewer_Local_Draft_HintInputs */

const vi_einvoice_viewer_local_draft_hint = /** @type {(inputs: Einvoice_Viewer_Local_Draft_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bản nháp trong hệ thống, chưa gửi MISA và chưa phát hành.`)
};

/**

* @param {Einvoice_Viewer_Local_Draft_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_viewer_local_draft_hint = /** @type {((inputs?: Einvoice_Viewer_Local_Draft_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Viewer_Local_Draft_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_viewer_local_draft_hint(inputs)
});